<template>
  <!-- 填空题 -->
  <el-dialog
    class="answer-dialog dialog"
    title="解答题"
    width="800px"
    top="10px"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="dialogClose"
    append-to-body
  >
    <el-form
      ref="formData"
      class="demo-Form"
      inline
      :model="formData"
      :rules="rulesFrom"
    >
      <el-form-item label="大题题号：" prop="th">
        <el-select
          v-model="formData.th"
          placeholder="请选择"
          style="width: 100px"
          size="small"
        >
          <el-option
            v-for="item in ths"
            :key="'th' + item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="limit-title" label="题目名称：" prop="name">
        <el-input
          class="topic_name"
          v-model="formData.name"
          placeholder="请输入内容"
          maxlength="27"
          show-word-limit
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item class="limit-title" prop="hasUnderLine">
        <el-checkbox v-model="formData.hasUnderLine">显示答题横线</el-checkbox>
      </el-form-item>
      <el-form-item
        v-if="formData.hasUnderLine"
        class="limit-title wh75"
        label="每题行数："
        prop="linNum"
      >
        <el-input
          v-model="formData.lineNum"
          size="small"
          type="phone"
          style="width: 100px"
        ></el-input>
        <!-- <el-input-number
          v-model="formData.lineNum"
          :controls="false"
          size="small"
          type="number"
        ></el-input-number> -->
      </el-form-item>
      <div></div>

      <div class="el-form-item">
        <label class="el-form-item__label">{{
          "题\xa0\xa0\xa0\xa0\xa0\xa0号："
        }}</label>
        <el-form-item prop="start" ref="start_inp">
          <IntegerInput v-model="formData.start" />
          <!-- <el-input-number v-model="formData.start" :controls="false" size="small" :min="1"></el-input-number> -->
        </el-form-item>
        <!-- <span class="dia-name" style="padding: 0 10px">至</span> -->
        <!-- <el-form-item prop="end" ref="end_inp">
          <IntegerInput v-model="formData.end" />
        </el-form-item> -->
      </div>
      <el-form-item :label="'小题号：'" prop="xTHValue" class="wh75">
        <el-select
          v-model="formData.xTHValue"
          placeholder="请选择"
          style="width: 100px"
          size="small"
        >
          <el-option
            v-for="(item, i) in formData.xThs"
            :key="i"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <span class="dia-name" style="padding: 0 10px">{{ thDescText }}</span>
      <el-form-item prop="end" ref="end_inp">
        <IntegerInput v-model="formData.end" />
      </el-form-item>
      <span class="dia-name" style="padding: 0 10px 0 0">题</span>
      <el-form-item
        :label="'每\xa0\xa0\xa0\xa0\xa0\xa0题：'"
        prop="score"
        class="wh75"
      >
        <el-input-number
          v-model="formData.score"
          :controls="false"
          size="small"
          type="number"
          :precision="2"
          
        ></el-input-number>
        <span>分</span>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-plus"
          style="margin-left: 15px"
          @click="addItems"
          circle
          size="mini"
        ></el-button>
      </el-form-item>
    </el-form>

    <div class="dialog-cont">
      <el-button class="clear-table" type="text" @click="clearList(true)"
        >清空列表</el-button
      >
      <div class="dialog-list">
        <el-table :data="formData.items" height="300px" style="width: 100%">
          <el-table-column label="题号" align="center">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  justify-items: center;
                  align-items: center;
                "
              >
                <!-- <span style="display: block; width: 26px">{{
                  scope.row.no
                }}</span> -->
                <el-input-number
                  :controls="false"
                  v-model="scope.row.no"
                  type="text"
                  size="small"
                  style="display: block; width: 160px"
                />
                <span style="margin: 0 6px">{{
                  scope.row.xth == 0 ? "" : "."
                }}</span>
                <!-- <el-input
                  style="width: 100%"
                  v-model="scope.row.xth"
                  size="small"
                ></el-input> -->
                <span>{{ scope.row.xth == 0 ? "" : scope.row.xth }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="分值" align="center">
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.score" size="small"></el-input> -->
              <el-input-number
                :controls="false"
                v-model="scope.row.score"
                type="number"
                :precision="2"
                size="small"
              />
            </template>
          </el-table-column>

          <el-table-column label="行数" align="center">
            <template slot-scope="scope">
              <!-- <el-input v-model="scope.row.score" size="small"></el-input> -->
              <el-input-number
                controls-position="right"
                v-model="scope.row.lineNum"
                type="number"
                :precision="0"
                size="small"
              />
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="deleteItem(scope)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { AnswerModel } from "./Answer.model";
import { THS } from "../constant";
import { mapState, mapMutations, mapActions } from "vuex";
import { overNum } from "@/utils/common";
import { XTH_TYPE_KONG } from "./Answer.model";
import { initTopicBoxMixins } from "@/mixins/initTopicBoxFormData.mixins";

export default {
  name: "Answer",
  props: ["value", "type", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapState("card", {
      ths: (state) => state.THS,
    }),
  },
  data(ctx) {
    var tihaoR = (rule, value, callback) => {
      value = Number(value);
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (
        ctx.formData.xTHValue == XTH_TYPE_KONG &&
        rule.field === "start" &&
        value > Number(ctx.formData.end)
      ) {
        callback(new Error("开始题号过大"));
      } else if (
        ctx.formData.xTHValue == XTH_TYPE_KONG &&
        rule.field === "end" &&
        value < Number(ctx.formData.start)
      ) {
        callback(new Error("开始题号过大"));
      } else {
        if (rule.field === "start") {
          this.$refs["end_inp"].clearValidate();
        } else {
          this.$refs["start_inp"].clearValidate();
        }
        callback();
      }
    };
    let thValidateEmpty = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填"));
      } else {
        callback();
      }
    };
    return {
      thDescText: "至",
      place: "&nbsp;",
      loading: false,
      formData: new AnswerModel(),
      isClickAdd: 0,
      changeObj: {},
      rulesFrom: {
        th: [{ validator: thValidateEmpty, trigger: "blur" }],
        name: [{ validator: thValidateEmpty, trigger: "blur" }],
        start: [{ validator: tihaoR, trigger: "blur" }],
        end: [{ validator: tihaoR, trigger: "blur" }],
        score: [{ validator: tihaoR, trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    createItems() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // 如果是编辑就追加题型
          if (this.subject) {
            let checkResult = false;
            checkResult = this.checkAll(checkResult);
            if (checkResult) {
              return;
            }
            const flag = overNum(this, 50);
            if (flag) return;
          } else {
            if (
              !this.formData.items.length &&
              this.formData.end - this.formData.start > 50
            ) {
              this.$message({
                message: "超出50题，无法添加！",
                type: "warning",
                customClass: "mzindex",
              });
              this.addButtonLoading = false;
              return;
            }
            let checkResult = false;
            checkResult = this.checkAll(checkResult);
            if (checkResult) {
              return;
            }
            const flag = overNum(this, 50);
            if (flag) return;
          }
          // this.subject
          //   ? this.formData.addItems(this.formData)
          //   : this.formData.createItems(this.formData);
          console.log('this.formData.addItems this.formData.addItems',this.formData);
          this.formData.addItems(this.formData);
          this.clearHistoryTopicFormData("creatItems");
        } else {
        }
      });
    },
    checkAll(checkResult) {
      checkResult = !checkResult && this.checkXTHToI(this.formData.xTHValue);
      checkResult =
        (!checkResult && this.checkXTHToA(this.formData.xTHValue)) ||
        checkResult;
      checkResult =
        (!checkResult && this.checkXTHToNumber(this.formData.xTHValue)) ||
        checkResult;
      checkResult =
        (!checkResult && this.checkXTHToNumberDouble(this.formData.xTHValue)) ||
        checkResult;
      return checkResult;
    },
    /**
     * 判断小题号类型 I II
     */
    checkXTHToI(value) {
      if (value == "Ⅰ") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 a b c d e
     */
    checkXTHToA(value) {
      if (value == "a") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 (1)
     */
    checkXTHToNumberDouble(value) {
      if (value == "(1)") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 ①
     */
    checkXTHToNumber(value) {
      if (value == "①") {
        if (this.formData.end > 10) {
          this.$message({
            message: "此类题型小题号不能超出10题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    //添加小题
    addItems() {
      console.log('this.formData.lineNum:::::::',{num:this.formData.lineNum,formData:this.formData});
      if (this.subject) {
        if (this.isClickAdd === 0) {
          if (
            this.subject.start > this.formData.start ||
            this.subject.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              lineNum: this.formData.lineNum,
            };
            this.isClickAdd = 1;
          } else {
            const obj = JSON.parse(JSON.stringify(this.subject));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              lineNum: this.formData.lineNum,
            };
          }
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              lineNum: this.formData.lineNum,
            };
          }
        }
      } else {
        // 新增
        if (!this.changeObj.start) {
          const obj = JSON.parse(JSON.stringify(this.formData));
          this.changeObj = {
            ...this.changeObj,
            start: obj.start,
            end: obj.end,
            score: obj.score,
            lineNum: this.formData.lineNum,
          };
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              lineNum: this.formData.lineNum,
            };
          }
        }
      }

      this.createItems("formData");
    },
    //
    handleScoreChange(val) {
      this.formData.items &&
        this.formData.items.forEach((item) => {
          item.score = val;
        });
    },
    clearList() {
      this.formData.items = [];
    },
    deleteItem(scope) {
      const idx = scope.$index;
      this.formData.deleteItem(idx);
    },
    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
      this.$emit("input", false);
    },
    dialogSubmit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      if (!this.formData.items.length) {
        this.$message({
          type: "warning",
          message: "列表不能为空，请点击‘+’号按钮，添加题号！",
          customClass: "mzindex",
        });
        return;
      }
      if (this.changeObj.start) {
        const obj = JSON.parse(JSON.stringify(this.changeObj));
        this.formData = { ...this.formData, score: obj.score };
      }
      const { items } = this.formData;
      if (items && items.length) {
        this.formData.start = items[0].no;
        this.formData.end = items[items.length - 1].no;
        this.formData.totalScore = 0; // 总分重新计算
        items.forEach((item) => {
          this.formData.totalScore += item.score;
        });
      }
      this.$emit("submit-answer", new AnswerModel(this.formData));
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
    },
  },
  watch: {
    value: {
      //handler:'test',
      handler(val) {
        if (val) {
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
            const obj = JSON.parse(JSON.stringify(this.subject));
            this.changeObj = { ...this.changeObj, score: obj.score };
          }
          this.subject
            ? (this.formData = new AnswerModel(this.subject.oldSubject))
            : (this.formData = new AnswerModel(this.type));
          !this.subject && this.clearHistoryTopicFormData();
        }
      },
      immediate: true,
    },
    "formData.xTHValue": {
      handler(val) {
        if (val != XTH_TYPE_KONG) {
          // 代表小题号不为空
          this.thDescText = "共";
        } else {
          this.thDescText = "至";
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  lang="scss">
.dialog {
  .clear-table {
    margin-left: 10px;
  }
  .limit-title {
    .el-input__inner {
      padding-right: 50px;
    }
  }
}
</style>
